<template>
  <div>
    <Top></Top>
    <div class="main">
      <h2>物流追跡サイト</h2>
      <p>ご利用になられた配送業者の追跡番号をご記入して頂けると、配送状態を確認できます。</p>
      <p>
        基本配送した翌日午後から確認でき、確認できない場合は詳細確認が必要な為、サポートスタッフまでご連絡ください。
        運送会社に問い合わせ確認を致します。
      </p>
      <ul>
        <li>
          <img src="../../assets/img/lg1.jpg" alt />
          <div class="search">
            <input type="text" placeholder="配送番号" v-model="val" />
            <!-- <button>検索</button> -->
            <a
              :href="'https://webcsw.ocs.co.jp/csw/ECSWG0201R00003P.do?cwbno='+val"
              target="_blank"
            >検索</a>
          </div>
        </li>
        <li>
          <img src="../../assets/img/lg2.png" alt />
          <div class="search">
            <input type="text" placeholder="配送番号" v-model="val1" />
            <a
              :href="'https://trackings.post.japanpost.jp/services/srv/search/direct?reqCodeNo1='+val1 +'&searchKind=S002&locale=ja'"
              target="_blank"
            >検索</a>
          </div>
        </li>
        <li>
          <img src="../../assets/img/lg3.png" alt />
          <div class="search">
            <input type="text" placeholder="配送番号" v-model="val2" />
            <a href="javascript:;">検索</a>
          </div>
        </li>
      </ul>
      <dl>
        <dt>そのほか</dt>
        <dd>電子便：http://www.bt-exp.com/</dd>
        <dd>
          <img src="../../assets/img/delivery1.png" alt />
        </dd>
        <dd>ＺＣ便： http://www.sagawa-exp.co.jp/</dd>
        <dd>
          <img src="../../assets/img/delivery2.png" alt />
        </dd>
      </dl>
    </div>
    <Foot></Foot>
  </div>
</template>
<script>
import Top from "../../components/head/Top";
import Foot from "../../components/foot/Foot";
export default {
  data() {
    return {
      val: "",
      val1: "",
      val2: ""
    };
  },
  components: {
    Top,
    Foot
  },
  methods: {}
};
</script>
<style lang='scss' scoped>
.main {
  width: 1200px;
  margin: 0 auto 150px;
  h2 {
    text-align: center;
    font-size: 36px;
    font-weight: 700;
    margin: 120px 0 80px;
  }
  p {
    font-size: 18px;
    margin-bottom: 60px;
  }
  ul {
    li {
      margin-top: 120px;
      text-align: center;
      overflow: hidden;
      .search {
        margin: 60px auto 0;
        width: 838px;
        input {
          width: 585px;
          height: 100px;
          border: 1PX solid #ccc;
          float: left;
          padding-left: 40px;
          font-size: 25px;
          &::placeholder {
            color: #ccc;
            font-size: 14px;
          }
        }
        a {
          display: block;
          float: left;
          width: 200px;
          height: 102px;
          line-height: 102px;
          background: #F3C622;
          text-align: center;
          line-height: 102px;
          color: #fff;
          font-size: 25px;
        }
      }
    }
  }
  dl {
    margin: 50px 0;
    dt {
      font-size: 30px;
    }
    dd {
      margin-left: 120px;
      font-size: 24px;
      margin-top: 80px;
    }
  }
}
</style>